(function () {
  var cfg = window.bvAgeGate || {};
  var MIN_AGE = cfg.minAge || 18;
  var REMEMBER_DAYS = cfg.rememberDays || 30;

  // Original storage keys retained so previously verified shoppers aren't re-prompted.
  var SESSION_KEY = 'bladeVipSessionVerified';
  var LOCAL_KEY = 'bladeVipDaysVerified';

  function verified() {
    try {
      if (sessionStorage.getItem(SESSION_KEY)) return true;
      var raw = localStorage.getItem(LOCAL_KEY);
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (Date.now() < data.expiry) return true;
      localStorage.removeItem(LOCAL_KEY);
    } catch (e) {
      return document.cookie.indexOf('bvAgeVerified=1') !== -1;
    }
    return false;
  }

  function remember(persist) {
    try {
      if (persist) {
        localStorage.setItem(LOCAL_KEY, JSON.stringify({ expiry: Date.now() + REMEMBER_DAYS * 86400000 }));
      } else {
        sessionStorage.setItem(SESSION_KEY, 'true');
      }
    } catch (e) {
      var exp = new Date(Date.now() + REMEMBER_DAYS * 86400000).toUTCString();
      document.cookie = 'bvAgeVerified=1; expires=' + exp + '; path=/; SameSite=Lax';
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    var gate = document.getElementById('bv-age-gate');
    if (!gate || verified()) return;

    var monthEl = document.getElementById('bv-dob-month');
    var dayEl = document.getElementById('bv-dob-day');
    var yearEl = document.getElementById('bv-dob-year');
    var errorEl = document.getElementById('bv-age-error');
    var panel = gate.querySelector('.bv-age-gate__panel');

    for (var d = 1; d <= 31; d++) dayEl.add(new Option(d, d));
    var thisYear = new Date().getFullYear();
    for (var y = thisYear; y >= 1920; y--) yearEl.add(new Option(y, y));

    gate.hidden = false;
    document.body.classList.add('bv-age-locked');
    panel.focus();

    function fail(message) {
      errorEl.textContent = message;
      errorEl.hidden = false;
    }

    document.getElementById('bv-age-submit').addEventListener('click', function () {
      var month = parseInt(monthEl.value, 10);
      var day = parseInt(dayEl.value, 10);
      var year = parseInt(yearEl.value, 10);

      if (!month || !day || !year) {
        fail('Select a complete date.');
        return;
      }

      var today = new Date();
      var dob = new Date(year, month - 1, day);
      var age = today.getFullYear() - dob.getFullYear();
      var m = today.getMonth() - dob.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) age--;

      if (age >= MIN_AGE) {
        remember(document.getElementById('bv-age-remember').checked);
        gate.hidden = true;
        document.body.classList.remove('bv-age-locked');
        var main = document.getElementById('MainContent');
        if (main) main.focus();
        return;
      }

      // Under age: send them to the department they can shop, not off-site.
      fail('You need to be ' + MIN_AGE + ' or older for Blades. Taking you to Threads.');
      setTimeout(function () {
        window.location.href = cfg.declineUrl || '/collections/clothing';
      }, 1800);
    });

    // Escape is not an exit - the shopper has to choose.
    gate.addEventListener('keydown', function (event) {
      if (event.key !== 'Tab') return;
      var focusable = gate.querySelectorAll('button, a[href], select, input');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  });
})();
